"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _utils = require("../../utils/utils");
var _katalFunnelEvents = require("../../events/katal-funnel-events");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BwaRedirectFallbackPopupRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function BwaRedirectFallbackPopupRenderHandler(checkoutUrl) {
    var _this;
    var checkoutId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    (0, _classCallCheck2["default"])(this, BwaRedirectFallbackPopupRenderHandler);
    _this = _callSuper(this, BwaRedirectFallbackPopupRenderHandler);
    _this.checkoutUrl = checkoutUrl;
    _this.checkoutId = checkoutId;
    _this.pre.push(function () {});
    _this.overlay = null;
    _this.modal = null;
    return _this;
  }
  (0, _inherits2["default"])(BwaRedirectFallbackPopupRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(BwaRedirectFallbackPopupRenderHandler, [{
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.render();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var container = document.getElementById('bwa-checkout-address-fill-selection-container');
      if (container) {
        container.remove();
      }
      this.overlay = document.createElement('div');
      this.overlay.className = 'bwa-redirect-fallback-modal-overlay';
      this.modal = document.createElement('div');
      this.modal.className = 'bwa-redirect-fallback-modal';
      this.modal.innerHTML = "\n            <div class=\"bwa-redirect-fallback-subtitle\">Not working? Continue directly to checkout</div>\n            <div class=\"bwa-redirect-fallback-buttons\">\n                <button class=\"bwa-redirect-fallback-btn bwa-redirect-fallback-btn-continue\">Go to Checkout \u2192</button>\n            </div>\n        ";
      document.body.appendChild(this.overlay);
      document.body.appendChild(this.modal);
      document.body.classList.add('bwa-no-scroll');

      // Funnel: popup was shown (redirect stalled past the fallback window).
      (0, _katalFunnelEvents.logFunnelEvent)(_katalFunnelEvents.FUNNEL_EVENTS.MANDATE_FALLBACK_POPUP_SHOWN, {
        checkoutId: this.checkoutId
      });
      var continueBtn = this.modal.querySelector('.bwa-redirect-fallback-btn-continue');
      continueBtn.addEventListener('click', function () {
        // Funnel: shopper recovered via the manual fallback (goes straight to checkout,
        // bypassing the address page). shown-minus-clicked = abandoned at the popup.
        (0, _katalFunnelEvents.logFunnelEvent)(_katalFunnelEvents.FUNNEL_EVENTS.MANDATE_FALLBACK_POPUP_CLICKED, {
          checkoutId: _this2.checkoutId
        });
        (0, _utils.sendGaData)('bwa_redirect_fallback_continue', {});
        window.location.href = _this2.checkoutUrl;
      });
    }
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=bwa-redirect-fallback-popup-render-handler.js.map
